module.exports = __webpack_public_path__ + "static/media/en-data-roaming-iphone_6.ccbf9b46.png";